/**
 * @fileoverview Pantalla 7 — Confirmación.
 * Cierre limpio con agradecimiento. La tablet se reutiliza entre
 * asistentes: la sesión anterior se limpia por completo aquí y el
 * regreso a la pantalla de código es solo mediante "Regresar al inicio".
 */

import { CheckCircle2 } from "lucide-react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { AppShell } from "../components/AppShell";
import { Button } from "../components/ui/button";
import { useLimpiarSesion } from "../context/ParticipacionContext";

export function Confirmacion() {
    const navigate = useNavigate();
    const limpiar = useLimpiarSesion();

    // La participación ya fue enviada: limpiamos toda la sesión anterior
    // (código, votos, índice, participacion_id, sessionStorage) para que
    // la siguiente persona empiece desde cero y no se pueda volver atrás.
    useEffect(() => {
        limpiar();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function handleRegresarInicio() {
        limpiar();
        navigate("/", { replace: true });
    }

    return (
        <AppShell testid="page-confirmacion" showBrand>
            <div className="text-center space-y-6 py-8 sm:py-12">
                <div
                    className="inline-flex w-16 h-16 rounded-full bg-vote-acuerdo-soft items-center justify-center"
                    aria-hidden
                >
                    <CheckCircle2 size={32} className="text-vote-acuerdo" />
                </div>
                <div className="space-y-3 max-w-md mx-auto">
                    <h1 className="font-serif-headline text-3xl sm:text-4xl font-semibold text-foreground">
                        ¡Gracias por participar!
                    </h1>
                    <p
                        className="text-base text-muted-foreground leading-relaxed"
                        data-testid="confirmacion-mensaje"
                    >
                        Tus respuestas fueron enviadas correctamente.
                    </p>
                    <p className="text-base text-muted-foreground leading-relaxed">
                        Tu participación es muy importante para la construcción de la nueva
                        Ley de Participación Ciudadana.
                    </p>
                </div>
                <div className="pt-4">
                    <Button
                        size="lg"
                        onClick={handleRegresarInicio}
                        className="h-12 px-8 font-semibold w-full sm:w-auto"
                        data-testid="regresar-inicio-btn"
                    >
                        Regresar al inicio
                    </Button>
                </div>
            </div>
        </AppShell>
    );
}
